export default __webpack_public_path__ + "static/media/2.82802761.png";